import React from "react";
import InternalLayout from "../components/InternalLayout";
import Content from "../components/AccountCharts/get-all-accounts-api";
import AccountChartsComponent from "../components/AccountCharts";
import withAuth from "../config/private-route";

const AccountCharts = () => {
  return (
    <InternalLayout>
      <Content />
      <AccountChartsComponent />
    </InternalLayout>
  );
};
export default withAuth(AccountCharts);
